import { connect } from 'react-redux';

import {
  removeFunnelStep,
  setFunnelStepClosingRange,
  setFunnelStepCount,
  setFunnelStepEventName,
  setFunnelStepOptionalStatus,
  setFunnelStepLegendName,
  toggleFunnelEnabled,
} from '../../../../../actions/dashboards/funnels';
import { getEventNames, getUpdatingFunnelDashboard } from '../../../../../reducers/analyticsApp';
import FunnelUpdateStep from '../../../../../components/funnel/update/Step';

// TODO: pass only step id and retrieve all required info here?
const mapStateToProps = (state, { unit, stepIndex, firstEnabledStepIndex }) => {
  const { steps } = getUpdatingFunnelDashboard(state, unit.id);
  const stepsWithoutCurrent = [...steps.slice(0, stepIndex), ...steps.slice(stepIndex + 1)];
  const isOnlyEnabledStep = stepsWithoutCurrent.every((step) => !step.enabled);

  return {
    events: getEventNames(state),
    legendName: steps[stepIndex].legendName || '',
    first: !stepIndex || stepIndex === firstEnabledStepIndex,
    perStepClosingRangeEnabled: true,
    isOnlyEnabledStep,
  };
};

const mapDispatchToProps = (dispatch, { stepIndex, unit }) => ({
  setEventName: (event) => dispatch(setFunnelStepEventName(stepIndex, event, unit.id)),
  setLegendName: (name) => dispatch(setFunnelStepLegendName(stepIndex, name, unit.id)),
  setClosingRange: (closingRange) =>
    dispatch(setFunnelStepClosingRange(stepIndex, closingRange, unit.id)),
  removeStep: () => dispatch(removeFunnelStep(stepIndex, unit.id)),
  toggleEnabled: () => dispatch(toggleFunnelEnabled(stepIndex, unit.id)),
  setOptionalStatus: (status) => dispatch(setFunnelStepOptionalStatus(stepIndex, status, unit.id)),
  setStepCount: (count, operator) =>
    dispatch(setFunnelStepCount(stepIndex, count, operator, unit.id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FunnelUpdateStep);
